exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Copyright__copyRight___1Wd5D {\n  font-size: 14px;\n  font-weight: 400;\n  opacity: 50%; }\n", ""]);

// exports
exports.locals = {
	"copyRight": "Copyright__copyRight___1Wd5D"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Footer/Copyright/Copyright.scss
// module id = 2072
// module chunks = 6